// extracted by mini-css-extract-plugin
export default {"advertSearchLink":"_2rm2v27n","advertSearchIcon":"oYx0P+PS"};